import { useQuery } from "@tanstack/react-query";
import { MeResponseSchema } from "#shared/schemas/user.ts";
import { api } from "@web/lib/api.ts";

/** Local CoyKoi user from `GET /api/me` (includes `is_admin`). */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => MeResponseSchema.parse(await api("/api/me")),
    staleTime: 60_000,
  });
}

export function useIsAdmin(): boolean {
  const me = useMe();
  return me.data?.user.is_admin === true;
}
